import { jsxs as m, jsx as d } from "react/jsx-runtime";
import { useTranslation as u, FieldLabel as f } from "@systemeio/ui";
import { twJoin as h } from "tailwind-merge";
import { usePhysicalProductStore as g } from "../../../../../store/index.mjs";
import { doesShippingServicesHaveShippingMethod as x } from "../../utils/have-shipping-method.mjs";
import { DefaultShipping as S } from "./default-shipping.mjs";
import { ShippingCondition as b } from "./shipping-condition.mjs";
import { useWatch as y } from "@systemeio/util";
const w = ({ shipping: o, isLoading: p }) => {
  const { t: c } = u(), { setSelectedShipping: t, selectedShipping: i } = g();
  y(i, (r) => {
    if (!(!o || !o.length) && !x(o, r))
      if (o[0]) {
        const n = o[0].rules[0], e = n.shippingConditions[0];
        t(e ? {
          ruleId: n.id,
          currency: n.currency,
          conditionId: e.id,
          price: e.price
        } : {
          ruleId: n.id,
          currency: n.currency,
          price: n.price
        });
      } else
        t(null);
  });
  const a = (r) => {
    t(r);
  };
  return typeof o > "u" ? null : /* @__PURE__ */ m("div", { className: h("flex flex-col gap-1", p && "animate-pulse"), children: [
    /* @__PURE__ */ d(f, { label: c("public_pages_purchase.shipping.shipping_method") }),
    /* @__PURE__ */ d("div", { className: "border-text-secondary/30 flex flex-col gap-4 rounded-lg border p-4", children: o.length ? o.map(
      (r, n) => r.rules.map(
        (e) => e.shippingConditions.length ? e.shippingConditions.map((l) => {
          const s = l.id === (i == null ? void 0 : i.conditionId) && e.id === (i == null ? void 0 : i.ruleId);
          return /* @__PURE__ */ d(
            b,
            {
              isSelected: s,
              onChange: a,
              service: r,
              rule: e,
              condition: l
            },
            l.id
          );
        }) : /* @__PURE__ */ d(
          S,
          {
            isSelected: e.id === (i == null ? void 0 : i.ruleId),
            onChange: a,
            service: r,
            rule: e
          },
          e.id
        )
      )
    ) : c("public_pages_purchase.shipping.not_available") })
  ] });
};
export {
  w as ShippingMethod
};
